import * as angular from "angular";
import {IController} from "angular";
import {LogisticsVehicle} from "../../models/logistics-vehicle.model";

export class LogisticsVehicleProfileCtrl implements IController {

  logisticsVehicle: LogisticsVehicle;

  private currentNavItem: any;

  constructor(private $state) {
  }

  $onInit() {
    this.currentNavItem = this.$state.current.url;
  }
}

angular
  .module('bringoz.admin.logistics-vehicle')
  .component('logisticsVehicleProfile', {
    bindings: {
      logisticsVehicle: '<'
    },
    template: require('./logistics-vehicle-profile.html').default,
    controller: LogisticsVehicleProfileCtrl
  });
